export function CourseFill() {
  return (
<svg data-fill viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 17.8241L16.1724 21.7172C17.3359 22.2395 18.6641 22.2395 19.8276 21.7172L28.5 17.8241V27.6974C28.5 29.7892 23.799 33 18 33C12.201 33 7.5 29.7892 7.5 27.6974V17.8241Z" fill="currentColor"/>
<path d="M19.8276 4.89174C18.6641 4.36942 17.3359 4.36942 16.1724 4.89174L3.89079 10.405C3.3491 10.6481 3 11.1907 3 11.7894C3 12.3881 3.3491 12.9307 3.89079 13.1739L16.1724 18.6871C17.3359 19.2094 18.6641 19.2094 19.8276 18.6871L32.1092 13.1739C32.6509 12.9307 33 12.3881 33 11.7894C33 11.1907 32.6509 10.6481 32.1092 10.405L19.8276 4.89174Z" fill="currentColor"/>
</svg>
  );
}
